// extracted by mini-css-extract-plugin
export default {"footerBtnsContainer":"FormStepsFooter_footerBtnsContainer__M7IR-"};